(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sa-cart-drawer"] && !Shopify.designMode) return;
  try {
    (async () => {
const { CartLinesUpdateEvent, StandardEvents } = await import('@shopify/events');
class SurfaceAreaCartDrawer extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('click', event => this.handleClick(event), options);
    this.addEventListener('keydown', event => {
      const panel=this.querySelector('[data-sa-promise-panel]');
      if(!panel || panel.hidden) return;
      if(event.key==='Escape'){event.preventDefault();event.stopPropagation();this.setPromise(false);}
      if(event.key==='Tab'){const buttons=[...panel.querySelectorAll('button:not(:disabled),a[href]')];const first=buttons[0],last=buttons.at(-1);if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}}
    }, options);
    this.closest('theme-drawer')?.addEventListener('theme-drawer:open', () => this.refresh().catch(error => this.showError(error.message)), options);
    document.addEventListener(StandardEvents.cartLinesUpdate, event => {
      event.promise?.then(({detail}) => {
        if (detail?.source === 'sa-cart-drawer' || detail?.didError) return;
        return this.refresh().then(() => { if (event.action === 'add') this.closest('theme-drawer')?.open(); });
      }).catch(error => this.showError(error.message));
    }, options);
    window.addEventListener('pageshow', event => { if (event.persisted) this.refresh().catch(() => {}); }, options);
  }
  disconnectedCallback() { this.controller?.abort(); }
  get root() { return window.Shopify?.routes?.root || '/'; }
  setPromise(open) {
    const panel=this.querySelector('[data-sa-promise-panel]');
    if(!panel)return;
    panel.hidden=!open;
    for(const sibling of panel.parentElement.children)if(sibling!==panel)sibling.inert=open;
    (open?panel.querySelector('[data-sa-promise-close]'):this.querySelector('[data-sa-promise-open]'))?.focus({preventScroll:true});
  }
  async handleClick(event) {
    const button = event.target.closest('button');
    if (!button || !this.contains(button)) return;
    if(button.hasAttribute('data-sa-promise-open')){this.setPromise(true);return;}
    if(button.hasAttribute('data-sa-promise-close')){this.setPromise(false);return;}
    if (button.hasAttribute('data-sa-slide')) {
      const rail = this.querySelector('.sa-cart__rail');
      rail?.scrollBy({left: Number(button.dataset.saSlide) * rail.clientWidth * .9, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      return;
    }
    if (this.busy) return;
    if(button.hasAttribute('data-sa-claim-free')){const id=Number(this.querySelector('[data-sa-free-select]')?.value);if(id)await this.mutate('add',{items:[{id,quantity:1}]});return;}
    if (button.hasAttribute('data-sa-change')) await this.mutate('change', {id:button.dataset.saChange, quantity:Number(button.dataset.quantity)});
    else if (button.hasAttribute('data-sa-add')) {
      const before=Number(this.querySelector('[data-sa-cart-render]').dataset.towelCount);
      const ok=await this.mutate('add', {items:[{id:Number(button.dataset.saAdd),quantity:1}]});
      const after=Number(this.querySelector('[data-sa-cart-render]').dataset.towelCount);
      if(ok && (before===1||before===3) && after===before+1){const panel=this.querySelector('[data-sa-free-inline]');if(panel){panel.scrollIntoView({block:'nearest'});panel.querySelector('select')?.focus({preventScroll:true});}}
    }
    else if (button.hasAttribute('data-sa-upgrade')) {
      const id = Number(this.querySelector('#sa-cart-upgrade-colour')?.value);
      if (id) await this.mutate('add', {items:[{id,quantity:Number(button.dataset.quantity)}]});
    }
  }
  async mutate(action, payload) {
    this.busy = true;
    this.setAttribute('aria-busy','true');
    this.querySelectorAll('button:not(.sa-cart__close),select').forEach(e => e.disabled = true);
    try {
      const response = await fetch(`${this.root}cart/${action}.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({...payload,sections:['cart-drawer-section'],sections_url:this.root})});
      if(response.status===429) throw new Error('Please wait a moment before updating your cart again.');
      const data = await response.json().catch(() => {throw new Error('We could not confirm the cart update. Please reload your cart before trying again.');});
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
      await this.refresh(data.sections?.['cart-drawer-section']);
      const count=Number(this.querySelector('[data-sa-cart-render]').dataset.count);
      try {
        const cartResponse = await fetch(`${this.root}cart.js`,{headers:{Accept:'application/json'},cache:'no-store'});
        if(cartResponse.ok){
          const cart = await cartResponse.json();
          this.dispatchEvent(new CartLinesUpdateEvent({action:action === 'add' ? 'add' : 'update',context:'cart',lines:[],promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{source:'sa-cart-drawer',itemCount:cart.item_count,didError:false}})}));
        }
      } catch {}
      this.querySelector('[data-sa-cart-live]').textContent = `${count} items in your cart.`;
      this.querySelector('.sa-cart__close')?.focus({preventScroll:true});
      return true;
    } catch(error) {
      try { await this.refresh(); } catch {}
      this.showError(error.message);
      return false;
    } finally {
      this.busy = false;
      this.removeAttribute('aria-busy');
      this.querySelectorAll('button,select').forEach(e => e.disabled = false);
    }
  }
  async refresh(html) {
    const revision = this.revision = (this.revision || 0) + 1;
    if (!html) {
      const response = await fetch(`${this.root}?sections=cart-drawer-section`,{cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Unable to refresh your cart. Please reload the page.');
      const sections = await response.json();
      html = sections['cart-drawer-section'];
    }
    if (revision !== this.revision) return;
    const next = new DOMParser().parseFromString(html || '', 'text/html').querySelector('[data-sa-cart-render]');
    if (!next) throw new Error('Your cart was updated. Please open the cart page to check it.');
    const old = this.querySelector('[data-sa-cart-render]');
    const scroll = old.querySelector('.sa-cart__body')?.scrollTop || 0;
    const detailsOpen = old.querySelector('details')?.open;
    old.replaceWith(next);
    if (detailsOpen && next.querySelector('details')) next.querySelector('details').open = true;
    if (next.querySelector('.sa-cart__body')) next.querySelector('.sa-cart__body').scrollTop = scroll;
    const count = Number(next.dataset.count || 0);
    document.querySelectorAll('cart-icon').forEach(icon => icon.renderCartBubble?.(count,false));
  }
  showError(message) { const node = this.querySelector('[data-sa-cart-error]'); if (node) { node.textContent = message; node.hidden = false; } }
}
if (!customElements.get('sa-cart-drawer')) customElements.define('sa-cart-drawer',SurfaceAreaCartDrawer);
})();
  } catch(e) { console.error(e); }
})();

})();
